import { render, staticRenderFns } from "./BusinessUsersView.vue?vue&type=template&id=dcb1d336"
import script from "./BusinessUsersView.vue?vue&type=script&lang=js"
export * from "./BusinessUsersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports